/**
 * Show/hide elements by toggling u-display-none css class.
 * @param {Array} selectors - css selectors
 * @param {Boolean} toogle - true shows the element, false hides it
 */
export const toggleElementsVisibility = (selectors, toogle) => {
  selectors.forEach(selector => $(selector).toggleClass('u-display-none', !toogle));
};
